import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { FilterFieldService } from '@shared/services/filter_field.service';
import { Router } from '@angular/router';
import { FilterCountService } from '@shared/services/filter_count.service';
import { CardsService } from '@shared/services/cards.service';
import { GAService } from '@app/@shared/services/google-analytics.service';

@Component({
  selector: 'search-field',
  templateUrl: './search-field.component.html',
  styleUrls: ['./search-field.component.scss'],
})
export class SearchFieldComponent implements OnInit {
  @Output() keyWords = new EventEmitter<string[]>();
  @Output() kwHidden = new EventEmitter<boolean>();
  @Output() inputWord = new EventEmitter<string>();
  @Input() map: boolean;
  @Input() filterPanel: BehaviorSubject<boolean>;

  public value: string;
  public filterCount: number;
  public isMobile: boolean;
  private subscriptions: Subscription[];
  @Input() set keywordInput(value: string) {
    this.value = value;
    this.kwHidden.emit(true);
    this.filterField.sharedValue$.next({ filter: value });
  }
  constructor(
    private filterField: FilterFieldService,
    private filtersCount: FilterCountService,
    private cardsList: CardsService,
    public router: Router,
    private gaService: GAService
  ) {
    this.isMobile =
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    this.cardsList.createKW();
    this.subscriptions = [];
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.filterField.sharedValue$.subscribe((v) => (this.value = v.filter))
    );
    this.subscriptions.push(
      this.filtersCount.sharedValue$.subscribe(
        (data) => (this.filterCount = data)
      )
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  filter(_data?: any) {
    this.sendClickSearchGaEvent(this.value);
    this.filterField.sharedValue$.next({ filter: this.value });
    this.kwHidden.emit(true);
  }

  openFilter(): void {
    this.filterPanel.next(false);
  }

  /**
   * Save all key event to store the searched string by user.
   * When Enter clicked, we pass data to our service and navigate to map.
   * @param $event
   */
  keyword($event: KeyboardEvent) {
    if ($event.key == 'Enter') {
      this.hideKeyboard();
      this.goToMapView();
    }

    // Case user don't enter value.
    if ($event.key !== 'Enter') {
      setTimeout(() => {
        if (this.cardsList.keywordList.length === 0) {
          setTimeout(() => {
            this.keyword($event);
          }, 250);
        } else {
          this.keyWords.emit(
            this.cardsList.keywordList
              .filter((r) =>
                this.normalize(r)?.includes(this.normalize(this.value))
              )
              .sort((a, b) => (a.length < b.length ? -1 : 1))
              .slice(0, 5)
          );
          this.inputWord.emit(this.value);
        }
      }, 500);
    }
  }

  /**
   * Async function to make the view wait 1s while closing keyboard.
   */
  private async goToMapView() {
    new Promise((_) =>
      setTimeout(() => this.router.navigate(['/carte']), 1000)
    );
  }

  /**
   * Function that we use because the mobile keyboard is an issus when loading maps.
   * We have to close it before we launch the map view.
   * @param element
   */
  private hideKeyboard() {
    //this set timeout needed for case when hideKeyborad
    //is called inside of 'onfocus' event handler
    setTimeout(function () {
      //creating temp field
      const field = document.createElement('input');
      field.setAttribute('type', 'text');
      //hiding temp field from peoples eyes
      //-webkit-user-modify is nessesary for Android 4.x
      field.setAttribute(
        'style',
        'position:absolute; top: 0px; opacity: 0; -webkit-user-modify: read-write-plaintext-only; left:0px;'
      );
      document.body.appendChild(field);

      //adding onfocus event handler for out temp field
      field.onfocus = () => {
        //this timeout of 200ms is nessasary for Android 2.3.x
        setTimeout(() => {
          field.setAttribute('style', 'display:none;');
          setTimeout(() => {
            document.body.removeChild(field);
            document.body.focus();
          }, 14);
        }, 200);
      };

      //focusing it
      field.focus();
    }, 50);
  }

  normalize(text: string) {
    return text != undefined
      ? text
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLocaleLowerCase()
      : '';
  }

  /**
   * Send event on search field click.
   */
  private sendClickSearchGaEvent(searchData: string): void {
    if (searchData)
      this.gaService.sendEvent(`Recherche : ${searchData}`, 'Recherche');
    else this.gaService.sendEvent('Clic sur recherche', 'Recherche');
  }
}
